var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 1,
    y: 0,
    width: 270,
    height: 110,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.6%",
    y: "-4.5%",
    width: "105.2%",
    height: "112.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CONCEPT_menu-_hoover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu_hoover",
    transform: "translate(-976.000000, -106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_hoover",
    transform: "translate(957.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 270,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 18,
    y: 3,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7755,5.0545 C29.5695,5.0545 27.7755,6.8485 27.7755,9.0545 C27.7755,9.4485 27.8485,9.8595 27.9985,10.3105 L28.0965,10.6035 L20.7605,17.9395 C20.1755,18.5245 20.1755,19.4755 20.7605,20.0605 C21.3455,20.6455 22.2975,20.6455 22.8825,20.0605 L30.2135,12.7285 L30.5075,12.8275 C30.9615,12.9805 31.3765,13.0545 31.7755,13.0545 C33.2065,13.0545 34.5145,12.2745 35.2205,11.0545 L32.0445,11.0545 L30.3435,9.0545 L32.0445,7.0545 L35.2205,7.0545 C34.5145,5.8345 33.2065,5.0545 31.7755,5.0545 M21.8215,21.4985 C21.1815,21.4985 20.5415,21.2555 20.0535,20.7675 C19.0795,19.7935 19.0795,18.2065 20.0535,17.2325 L26.9585,10.3275 C26.8355,9.8855 26.7755,9.4665 26.7755,9.0545 C26.7755,6.2975 29.0185,4.0545 31.7755,4.0545 C33.8755,4.0545 35.7625,5.3935 36.4715,7.3875 L36.7085,8.0545 L32.5065,8.0545 L31.6565,9.0545 L32.5065,10.0545 L36.7085,10.0545 L36.4715,10.7215 C35.7625,12.7155 33.8755,14.0545 31.7755,14.0545 C31.3585,14.0545 30.9345,13.9935 30.4885,13.8675 L23.5895,20.7675 C23.1025,21.2555 22.4615,21.4985 21.8215,21.4985",
    id: "Fill-2",
    fill: "#050202"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.dcb7c4902be6e22d0e556a7b9cd65887.svg";
export { ForwardRef as ReactComponent };